import { useEffect, useState } from 'react';
import axios from 'axios';
import { GraduationCap, Clock, CheckCircle2, AlertTriangle, TrendingUp, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const TrainingWidget = () => {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/dashboard/training-widget`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching training widget:', error);
    }
  };

  if (!stats) return null;

  return (
    <div 
      className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(30,58,95,0.05)] border border-[rgba(30,58,95,0.05)] cursor-pointer hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(30,58,95,0.08)] transition-all duration-300" 
      onClick={() => navigate('/trainings')}
      data-testid="training-widget"
    >
      <div className="flex items-center justify-between mb-6">
        <h3 
          className="text-lg font-bold text-[#1e3a5f] flex items-center gap-2"
          style={{ fontFamily: 'Manrope, sans-serif' }}
        >
          <div className="bg-[#e8f4fc] p-2 rounded-lg">
            <GraduationCap size={20} className="text-[#0d9488]" />
          </div>
          Treinamentos
        </h3>
        <div className="text-right">
          <p className="text-3xl font-bold text-[#0d9488]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {stats.taxa_conclusao}%
          </p>
          <p className="text-xs text-[#64748b] font-medium">Taxa de Conclusão</p>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="mb-6">
        <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-[#0d9488] to-[#14b8a6] rounded-full transition-all duration-500"
            style={{ width: `${stats.taxa_conclusao}%` }}
          ></div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-emerald-50 p-4 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <CheckCircle2 size={16} className="text-emerald-600" />
            <p className="text-xs font-medium text-[#64748b]">Concluídos</p>
          </div>
          <p className="text-2xl font-bold text-emerald-600" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {stats.concluidos}
          </p>
        </div>

        <div className="bg-[#e8f4fc] p-4 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <Clock size={16} className="text-[#0d9488]" />
            <p className="text-xs font-medium text-[#64748b]">Em Andamento</p>
          </div>
          <p className="text-2xl font-bold text-[#0d9488]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {stats.em_andamento}
          </p>
        </div>

        <div className="bg-slate-50 p-4 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp size={16} className="text-[#64748b]" />
            <p className="text-xs font-medium text-[#64748b]">Pendentes</p>
          </div>
          <p className="text-2xl font-bold text-[#1e3a5f]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {stats.pendentes}
          </p>
        </div>

        <div className="bg-orange-50 p-4 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle size={16} className="text-orange-600" />
            <p className="text-xs font-medium text-[#64748b]">Vencendo</p>
          </div>
          <p className="text-2xl font-bold text-orange-600" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {stats.vencendo}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 mt-4 text-[#0d9488] font-medium text-sm">
        <span>Ver todos os treinamentos</span>
        <ArrowRight size={16} />
      </div>
    </div>
  );
};

export default TrainingWidget;
